import React from 'react';
import Link from 'next/link';
import Button from '../Button/Button';
import RegisteredMessage from '../Booking/RegisteredMessage';
import { ROUTES } from '@/config/routes';
import { T } from '@tolgee/react';

interface BookingButtonsProps {
  isBooked: boolean;
  bookingSuccessful: boolean;
  bookingId: string | null;
  onOpenModal: () => void;
  handleBookingClick: () => void;
  courseId: string;
  isDark?: boolean;
  className?: string;
}

const BookingButtons: React.FC<BookingButtonsProps> = ({
  isBooked,
  bookingSuccessful,
  bookingId,
  onOpenModal,
  handleBookingClick,
  isDark = false,
  className = 'md:left-12 md:bottom-12',
}) => {
  return (
    <div className={`flex mt-4 gap-5 relative md:absolute ${className}`}>
      {isBooked || bookingSuccessful ? (
        <>
          <Link href={ROUTES.BOOK_LIVE_COURSE(bookingId || '')} passHref prefetch={true}>
            <Button variant="primary">
              <T>live_classes.live_class_details.button.show_booking.label</T>
            </Button>
          </Link>
          <RegisteredMessage isDark={isDark} />
        </>
      ) : (
        <>
          <Button variant="primary" onClick={handleBookingClick}>
            <T>live_classes.live_class_details.button.register.label</T>
          </Button>
          <Button variant="secondary" bgColor="bg-transparent" onClick={onOpenModal}>
            <T>live_classes.more.label</T>
          </Button>
        </>
      )}
    </div>
  );
};

export default BookingButtons;
